//CheckModal.vue



<template>

<div class="overlay">

		<div class="modal">

			<div class="title">
				<div class="element">
					Check Predimension Results
				</div>
				<div  class="element">
					<img id="icon-cross" class="icon" src="imgs/icons/icon-cross-black.svg" @click="$emit('closeModalClicked')">
				</div>
			</div>

			<div class="modal-content">

				<!-- Slab -->
				<div class="member-container" id="container-slabs">
					<h2>Slabs</h2>
					<div class="slab" v-for="(slab, index) in this.memberResults.slabs" v-bind:key="slab">
						<p class="slab-text">
							Slab: {{ index + 1 }}, Level: {{ slab.level }}, Material: {{ slab.material }}, Cross section: {{ slab.height }}
						</p>
					</div>
				</div>

				<!-- Columns -->
				<div class="member-container" id="container-columns">
					<h2>Columns</h2>
					<div class="column" v-for="(column, index) in this.memberResults.columns" v-bind:key="column">
						<p class="column-text">
							Column: {{ index + 1 }}, Level: {{ column.level }}, Material: {{ column.material }}, Load: {{ column.load.toFixed(1) }} kN,
							Length: {{ column.length.toFixed(2)  + ' m' }}, Cross section: {{ crossSectionColumns[index] }}
						</p>
					</div>
				</div>

				<!-- Beams -->
				<div class="member-container" id="container-beams">
					<h2>Beams</h2>
					<div class="beam" v-for="(beam, index) in this.memberResults.beams" v-bind:key="beam">
						<p class="beam-text">
							<!-- Beam: {{ index + 1 }}, Level: {{ beam.level }}, Material: {{ beam.material }}, Load: {{ beam.load.toFixed(1) }} kN/m,
							Length: {{ beam.length.toFixed(2) + ' m' }}, Cross section: {{ crossSectionBeams[index] }} -->
							Beam: {{ index + 1 }}, Level: {{ beam.level }}, Material: {{ beam.material }}, Load: {{ toFixedForBeams(beam.load) }} kN/m,
							Length: {{ beam.length.toFixed(2) + ' m' }}, Cross section: {{ crossSectionBeams[index] }}
						</p>
					</div>
				</div>
				
			</div>

			<button id="button-close-modal" @click="$emit('closeModalClicked')">
				Close
				<i id="arrow-right" class="fas fa-chevron-right"></i>
			</button>

		</div>
</div>
  
</template>

<script>


import * as StructuralMember from "../classes/StructuralMember.js";

export default {
	emits: [
			'closeModalClicked',
	],
	props: {
		memberResults: Object,
		structSystem: String
		}
	,
	data() {
		return {
			memberResultsDeep: this.memberResults,
			crossSectionBeams: [],
			crossSectionColumns: []
		}; 
	},
	methods: {
		toFixedForBeams(load) {

			var result;

			if(load >= 0) {
				result = load.toFixed(1);
			}
			else {
				result = "see slab";
			}
			
			return result;
		}
	},
	mounted() {
		// console.log("Hey from modal");
		// console.log(this.memberResults);

		// console.log("structSystem from modal");
		// console.log(this.structSystem);

		//Set beam cross section for modal
		for (let i = 0; i < this.memberResults.beams.length; i++) {
			// console.log(StructuralMember.beamCrossSectionToString( this.memberResults.beams[i], this.structSystem ));	
			var crossSectionBeam = StructuralMember.beamCrossSectionToString( this.memberResults.beams[i], this.structSystem );
			this.crossSectionBeams.push(crossSectionBeam);	
		}

		//Set column cross section for modal
		for (let i = 0; i < this.memberResults.columns.length; i++) {
			// console.log(StructuralMember.columnCrossSectionToString( this.memberResults.columns[i], this.structSystem ));	
			var crossSectionColumn = StructuralMember.columnCrossSectionToString( this.memberResults.columns[i], this.structSystem );
			this.crossSectionColumns.push(crossSectionColumn);	
		}
	}
}

</script>

<style scoped>

.overlay {
	position: fixed; 
	top: 0%;
	left:0%;
	height: 100vh;
	width: 100vw;
	/* background: white; */
	background-color: transparent;
	backdrop-filter: blur(4px);
	z-index: 100;
}

.modal {
	position: fixed; 
	top: 20%;
	left: 30%;
	height: 60vh;
	width: 40vw;
	background: rgba(220, 220, 220, 0.7);
	border-radius: 30px;
	overflow: hidden;
	box-shadow: 0px 4px 12px -4px rgba(0, 0, 0, 0.3);
	border: 1px solid rgba(255, 255, 255, .2);

	/* background: transparent; */
	background-image: linear-gradient(rgba(230, 230, 230, .9),rgba(194, 194, 207, 0.8));
	/* background-image: linear-gradient(rgba(225, 225, 235, 1),rgba(119, 127, 158, 0.4)); */
	/* background-image: linear-gradient(rgba(225, 225, 235, 1),rgba(192, 194, 218, 0.4)); */
	backdrop-filter: blur(10px);
}

.title {
	font-family: 'Lato', sans-serif;
	height: 8%;
	/* border: 1px solid rgba(0, 0, 0, 1); */
	/* font-family: Roboto; */
	font-weight: 500;
	font-size: 1.5rem;
	padding: 3% 5% .5%;
	/* background: rgba(0, 0, 0, 1); */
	background: transparent;
	color: rgba(0, 0, 0, .8);
	justify-content: space-between;
	display: flex;
}

#icon-cross {
	height: 40%;
	cursor: pointer;
	opacity: .3;
}

#icon-cross:hover {
	opacity: .5;
}

.modal-content {
	padding: 3% 5%;

}

.member-container {
	padding: 0% 3%;
	border-radius: 10px; 
	/* border: 1px solid rgba(0, 0, 0, 1); */
	background: rgba(255, 255, 255, .1);
	/* background: transparent; */
	margin-bottom: 15px;
	border: 1px solid rgba(255, 255, 255, .3);
}

.member-container h2{
	color: rgba(0, 0, 0, .8);
	font-family: Roboto;
	font-weight: 400;
	font-size: 1rem;
	/* text-decoration: underline; */
}

#container-slabs{
	/* background: rgb(143, 188, 143, .4); */
	/* border: 2px solid rgb(143, 188, 143, .4); */
}

#container-columns{
	/* background: rgb(135, 206, 250, .4); */
	/* border: 2px solid rgb(135, 206, 250, .4); */
}

#container-beams{
	/* background: rgb(14, 82, 26, .4); */
	/* border: 2px solid rgb(14, 82, 26, .4); */
}

.modal-content {
	height: 70%;
	/* border: 1px solid black; */
	overflow-y: scroll;
	overflow-x: hidden;
	color: rgba(0, 0, 0, .70);
	font-family: Roboto;
	font-weight: 300;
	font-size: .75rem;
	margin-top: 0;
	/* border-radius: 20px;  */
}

#button-close-modal {
	border-radius: 25px;
	height: 6%;
	min-width: 80px;
	max-width: 120px;
	margin-top: 1.5%;
	margin-left: 4%;
	background: transparent;
	/* border: solid 1px black; */
	border: none;
	color:black;
	cursor: pointer;
	font-family: Roboto;
	font-weight: 500;
	font-size: .95rem;
	/* box-shadow: 0px 4px 12px -4px rgba(0, 0, 0, 0.3); */
}

#button-close-modal:active {
	background: rgba(235, 235, 235, 0.2);
	transform: translateY(1px);
}

#button-close-modal:hover > #arrow-right{
	transform: translateX(6px);
	transition: .3s ease-in;
}

#arrow-right {
	margin-left: 10%;
	font-size: .7rem;
}


/* width */
::-webkit-scrollbar {
  width: 8px;
  /* display: none; */
}

/* Track */
::-webkit-scrollbar-track {
	display: none;
	box-shadow: inset 0 0 5px grey; 
	border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
	background: rgba(0, 0, 0, .1); 
	border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	background: rgba(0, 0, 0, .2); ; 
}



</style>